
export class BaseModel {     
    $type: string;
    Id: number;    
    Version: string;
    
    constructor() {                
    }

}



